module.exports = __webpack_public_path__ + "img/letter-q.d3f519a2.svg";